import { render, staticRenderFns } from "./CustomerConversation.vue?vue&type=template&id=0bb72e0a"
import script from "./CustomerConversation.vue?vue&type=script&lang=js"
export * from "./CustomerConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports